<div class="page">
    <p>Local storage progress has been cleared</p>
</div>
